// 対象要素を取得
var $button = $('#headerLangButton');
var $navs = $('#headerLangNavs'); // 状態定義

var isNavShow = false; // ナビゲーションの表示状態を保存

/**
 * 関数定義
 */
// 表示切り替え

var switchNav = function switchNav() {
  // ナビゲーションの表示状態を切り替え
  isNavShow = isNavShow ? false : true; // ナビゲーションの表示状態に合わせて aria 属性値を変更

  $button.attr('aria-expanded', isNavShow);
  $navs.attr('aria-hidden', !isNavShow);
};
/**
 * イベント設定
 */


$button.on('click', function (event) {
  switchNav();
  return false;
});